import { useEffect, useState } from 'react'

import { Modal, Divider, TextInput, useModalStackContext } from '@mantine/core'

import Button from 'src/components/Buttons/Button/Button'
import DateInput from 'src/components/Inputs/DateInput/DateInput'

const STACK_ID = 'hired-modal'

const HiredModal = ({ onSave, onClose }) => {
  const stackCtx = useModalStackContext()

  // Mantine gap: Modal's stack-register useEffect has no cleanup, so
  // unmounting while opened leaks the stackId in Modal.Stack. Mirrors DeleteModal.
  useEffect(() => {
    return () => {
      if (stackCtx) {
        stackCtx.removeModal(STACK_ID)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date())
  const [content, setContent] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    const values: any = {
      applicantStageDate: selectedDate || new Date(),
    }
    if (content.trim() !== '') {
      values.content = content
    }
    onSave(values)
    onClose()
  }

  return (
    <Modal
      opened={true}
      onClose={onClose}
      classNames={{ title: 'text-lg font-bold' }}
      title="Hired"
      centered
      stackId={STACK_ID}
    >
      <form
        className="grid grid-cols-2 gap-4"
        onSubmit={handleSubmit}
      >
        <DateInput
          label="Hired Date"
          value={selectedDate}
          onChange={(date: Date | null) => setSelectedDate(date)}
        />
        <TextInput
          label="Notes"
          placeholder="Additional details or comments (optional)"
          className="col-span-2"
          value={content}
          onChange={(e) => setContent(e.currentTarget.value)}
        />
        <Divider className="col-span-2" />
        <Button text="Cancel" variant="outline" onClick={onClose} />
        <Button text="Save" type="submit" />
      </form>
    </Modal>
  )
}

export default HiredModal
